import styled from 'styled-components';

export const BannerContainer = styled.div<{ $hasImage?: boolean }>`
  background: ${props => props.$hasImage 
    ? 'transparent' 
    : '#1890ff'};
  padding: 32px;
  border-radius: 12px;
  margin-bottom: 24px;
  color: white;
  box-shadow: 
    0 2px 8px rgba(24, 144, 255, 0.2),
    0 4px 16px rgba(24, 144, 255, 0.1);
  position: relative;
  overflow: hidden;
  
  ${props => props.$hasImage && `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(24, 144, 255, 0.85);
      z-index: 1;
    }
    
    > * {
      position: relative;
      z-index: 2;
    }
  `}
`;

export const CoverImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 0;
`;

